/**
 * Largest single upload we accept, in megabytes. Kept below the backend's `upload_max_filesize` so a
 * file the browser lets through never trips a backend exception.
 */
export const MAX_FILE_SIZE_MB = 10

/**
 * Largest total request body we accept, in megabytes. Kept below the backend's `post_max_size`, and
 * below the inbound size limits of common mail clients, since attachments are forwarded by mail.
 */
export const MAX_POST_SIZE_MB = 15
